<template>
  <div>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-text>
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="text-h5">Reasignar Operacion</v-list-item-title>
              <v-list-item-subtitle>{{ editedItem.nombre }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-row>
            <v-col cols="6">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6">Estatus</v-list-item-title>
                  <v-list-item-subtitle class="mt-1">
                    <v-chip small label class="elevation-0" :color="editedItem.asignado ? 'success' : 'grey lighten-1'"
                      :text-color="editedItem.asignado ? 'white' : 'black'">
                      {{ editedItem.asignado ? 'Asignado' : 'Por asignar' }}
                    </v-chip>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="6">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6">Token (Cavidad)</v-list-item-title>
                  <v-list-item-subtitle class="mt-1">
                    <v-chip small label class="elevation-0" color="grey lighten-1" text-color="white">
                      {{ editedItem.token }}
                    </v-chip>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <v-card-text>
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle>Fecha Inicio</v-list-item-subtitle>
                <v-list-item-title style="font-weight: 600; color: #616161;">{{ editedItem.inicio }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle>Fecha Fin</v-list-item-subtitle>
                <v-list-item-title style="font-weight: 600; color: #616161;">{{ editedItem.fin }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-text>
            <v-row align="center" justify="center" class="text-center">
              <v-col cols="12" class="text-h4">Cantidad por asignar</v-col>
              <v-col cols="12" class="text-h2">{{ editedItem.cantidad }}</v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-text>
            <v-row align="center" justify="center" class="text-center">
              <v-col cols="12">
                <v-autocomplete v-model="selectedOrden" :items="ordenesOptions"
                  :disabled="loaderChange || editedItem.asignado" label="Orden de trabajo" item-text="text"
                  item-value="value" @change="onOrdenChange"></v-autocomplete>
              </v-col>

              <v-col cols="12">
                <v-autocomplete v-model="selectedDetalle" :items="detalleOptions" label="Artículo" item-text="text"
                  item-value="value" :disabled="!selectedOrden || loaderChange || editedItem.asignado"
                  @change="onDetalleChange"></v-autocomplete>
              </v-col>

              <v-col cols="12">
                <v-autocomplete v-model="selectedOperacion" :items="operacionOptions" label="Operación" item-text="text"
                  item-value="value"
                  :disabled="!selectedDetalle || loaderChange || editedItem.asignado"></v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" :loading="loaderChange" :disabled="loaderChange" text @click="dialog = false">
            {{ editedItem.asignado ? 'Cerrar' : 'Cancelar' }}
          </v-btn>
          <v-btn color="red darken-1" :loading="loaderChange" :disabled="loaderChange" v-if="!editedItem.asignado" text
            @click="save()">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Tabla -->
    <v-row>
      <v-col cols="3">
        <v-autocomplete v-model="maquinaSeleccionada" :items="tokensMaquinas" item-text="maquina"
          item-value="idMaquinaIns" label="Máquina" @change="onMaquinaChange($event); getDatosSn()" :loading="loadTokensExtras"
          :disabled="loadTokensExtras" clearable return-object />
      </v-col>

      <v-col cols="3">
        <v-autocomplete v-model="tokenSeleccionado" :items="tokensDisponibles" item-text="nombre"
          item-value="idTokenExtra" label="Token" :disabled="!tokensDisponibles.length" :loading="loadTokensExtras"
          return-object clearable @change="getDatosSn"/>
      </v-col>
      <v-col cols="3">
        <VueCtkDateTimePicker id="filtroFechaInicio" v-model="filtros.inicio" label="Fecha Inicio"
          format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm" noHeader overlay buttonNowTranslation="Ahora"
          clearable @input="getDatosSn()" />
      </v-col>
      <v-col cols="3">
        <VueCtkDateTimePicker id="filtroFechaFin" v-model="filtros.fin" label="Fecha Fin" format="YYYY-MM-DD HH:mm"
          formatted="YYYY-MM-DD HH:mm" noHeader overlay buttonNowTranslation="Ahora" clearable @input="getDatosSn(1)" />
      </v-col>
      <v-col cols="3">
        <v-autocomplete v-model="filtros.estado" :items="[
          { text: 'Activo', value: true },
          { text: 'Inactivo', value: false }
        ]" item-text="text" item-value="value" label="Estado" @input="getDatosSn()"/>
      </v-col>
      <v-col cols="12">
        <v-data-table :headers="headers" :items="desserts" :loading="loaderData">
          <template v-slot:item.asignado="{ item }">
            <v-chip v-if="item.asignado" color="green" text-color="white">Asignado</v-chip>
            <v-chip v-else color="red" text-color="white">Sin Asignar</v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">mdi-braille</v-icon>
            <!-- <v-icon small @click="deleteItem(item)">mdi-delete</v-icon> -->
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    maquinaSeleccionada: null,
      tokensDisponibles: [],
      tokenSeleccionado: null,
    filtros: {
      inicio: null,
      fin: null,
      estado: false
    },
    loaderChange: false,
    loaderData: false,
    dialog: false,
    dialogDelete: false,

    selectedOrden: null,
    selectedDetalle: null,
    selectedOperacion: null, // 👈 ahora es un objeto completo o null

    ordenesOptions: [],
    detalleOptions: [],
    operacionOptions: [],

    headers: [
      { text: 'Maquina Instancia', align: 'center', value: 'nombre', sortable: false },
      { text: 'Token Asignado', value: 'token', align: 'center', sortable: false },
      { text: 'Inicio', value: 'inicio', align: 'center', sortable: false },
      { text: 'Fin', value: 'fin', align: 'center', sortable: false },
      { text: 'Cantidad Reportada', value: 'cantidad', align: 'center', sortable: false },
      { text: 'Estatus', value: 'asignado', align: 'center', sortable: false },
      { text: 'Actions', value: 'actions', align: 'center', sortable: false },
    ],

    desserts: [],
    editedIndex: -1,
    editedItem: {
      asignado: false,
      cantidad: 0,
      fin: null,
      idDatoNoAsignado: null,
      idMaquinaIns: null,
      idTokenExtra: null,
      inicio: null,
      nombre: null,
      token: null,
      idArea: null,
      idTrabajoOrden: null,
      idTrabajoOrdenDetalle: null,
      idOperacion: null
    },
    defaultItem: {},
    odtsOpers: [],
    tokensMaquinas: [],
    loadTokensExtras: false
  }),

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.getOdtsOpers();
      this.getDatosSn();
      this.getMaquinasInsToken();
    },
    onMaquinaChange(maquina) {
      if (maquina) {
        this.tokensDisponibles = maquina.tokensExtras || [];

        // Si solo hay un token → seleccionarlo en automático
        if (this.tokensDisponibles.length === 1) {
          this.tokenSeleccionado = this.tokensDisponibles[0];
        } else {
          this.tokenSeleccionado = null;
        }
      } else {
        this.tokensDisponibles = [];
        this.tokenSeleccionado = null;
      }
    },
    getDatosSn(trigger = null) {
      this.loaderData = true;

      axios.get("/DatosSinAsignar", {
        params: {
          IdMaquinaIns: this.maquinaSeleccionada ? this.maquinaSeleccionada.idMaquinaIns : null,
          IdTokenExtra: this.tokenSeleccionado ? this.tokenSeleccionado.idTokenExtra : null,
          Inicio: this.filtros.inicio,          // string o Date en ISO
          Fin: this.filtros.fin,                // string o Date en ISO
          Estado: this.filtros.estado ?? false
        }
      })
        .then(res => this.desserts = res.data)
        .finally(() => this.loaderData = false);
    },

    getOdtsOpers() {
      axios.get("/TrabajoOrdenes/OtsAll")
        .then(res => {
          this.odtsOpers = res.data;
          this.ordenesOptions = this.odtsOpers.map(o => ({
            text: `${o.ot} ${o.clave}`,
            value: o.idTrabajoOrden,
            detalles: o.odtd
          }));
          if (this.ordenesOptions.length === 1) {
            this.selectedOrden = this.ordenesOptions[0].value;
            this.onOrdenChange(this.selectedOrden);
          }
        });
    },
    getMaquinasInsToken() {
      this.loadTokensExtras = true;
      axios.get("/Maquinas/MaquinasInstanciasTokens")
        .then(res => {
          this.tokensMaquinas = res.data;
          this.loadTokensExtras = false;
        });
    },
    onOrdenChange(idOrden) {
      this.selectedDetalle = null;
      this.selectedOperacion = null;
      this.operacionOptions = [];

      const orden = this.odtsOpers.find(o => o.idTrabajoOrden === idOrden);
      if (!orden) return;

      this.detalleOptions = orden.odtd.map(d => ({
        text: d.codigoArticulo ? `[${d.codigoArticulo}] - ${d.nombreArticulo}` : d.nombreArticulo,
        value: d.idTrabajoOrdenDetalle,
        operaciones: d.operacionesAll
      }));

      if (this.detalleOptions.length === 1) {
        this.selectedDetalle = this.detalleOptions[0].value;
        this.onDetalleChange(this.selectedDetalle);
      }
    },

    onDetalleChange(idDetalle) {
      this.selectedOperacion = null;

      const detalle = this.detalleOptions.find(d => d.value === idDetalle);
      if (!detalle) return;

      this.operacionOptions = detalle.operaciones.map(op => ({
        text: op.codigoArticulo ? `[${op.codigoArticulo}] - ${op.nombreArticulo}` : op.nombreArticulo,
        value: { idOperacion: op.idOperacion, idArea: op.idArea } // 👈 objeto completo
      }));

      if (this.operacionOptions.length === 1) {
        this.selectedOperacion = this.operacionOptions[0].value;
      }
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.selectedOrden = this.editedItem.idTrabajoOrden;
      this.selectedDetalle = this.editedItem.idTrabajoOrdenDetalle;
      this.selectedOperacion = {
        idArea: this.editedItem.idArea,
        idOperacion: this.editedItem.idOperacion
      };
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.selectedOrden = null;
        this.selectedDetalle = null;
        this.selectedOperacion = null;
      });
    },

    formatDate(dateString) {
      if (!dateString) return null;
      let normalized = dateString.replace("a. m.", "AM").replace("p. m.", "PM");
      const date = new Date(normalized);
      if (isNaN(date.getTime())) return null;
      const dd = String(date.getDate()).padStart(2, "0");
      const MM = String(date.getMonth() + 1).padStart(2, "0");
      const yyyy = date.getFullYear();
      const HH = String(date.getHours()).padStart(2, "0");
      const mm = String(date.getMinutes()).padStart(2, "0");
      return `${dd}/${MM}/${yyyy} ${HH}:${mm}`;
    },

    save() {
      this.loaderChange = true;
      const reporte = [{
        IdTrabajoOrden: this.selectedOrden,
        IdTrabajoOrdenDetalle: this.selectedDetalle,
        IdArea: this.selectedOperacion.idArea,
        IdOperacion: this.selectedOperacion.idOperacion,
        IdsMaquinasIns: this.editedItem.idMaquinaIns ? [this.editedItem.idMaquinaIns] : [],
        IdTokenExtra: this.editedItem.idTokenExtra || null,
        IdsOperadores: [1],
        Inicio: this.formatDate(this.editedItem.inicio),
        Fin: this.formatDate(this.editedItem.fin),
        Cantidad: this.editedItem.cantidad
      }];

      axios.post("Reportes/ReasignacionOperacion/" + this.editedItem.idDatoNoAsignado, reporte)
        .then(() => {
          this.loaderChange = false;
          this.dialog = false;
          this.initialize();
        })
        .catch(err => console.error(err));
    }
  }
};
</script>